/**
 *@author shaolei
 *@date 2020/04/07
 *@file_name:edit
 *@Description:新增订阅
 */
<template>
  <div class="edit">
    <div class="title">
      <div class="_p">新增订阅</div>
    </div>
    <div class="grey"></div>
    <div class="page_view">
      <component :is="view"></component>
    </div>
  </div>
</template>

<script>
import Form from '@/components/control/application/edit/form';
import Api from '@/components/control/application/edit/api';
export default {
  name: "edit",
  data() {
    return {
      step_index: 2,
      view:'v-api'
    };
  },

  components: {
    //组件声明
    'v-form':Form,
    'v-api':Api
  },

  computed: {
    //计算属性
  },

  created() {
    //创建时执行
  },

  mounted() {
    //数据挂载
  },

  methods: {
    //函数声明
    toLink(path) {
      this.$router.push(path);
    }
  }
};
</script>
<style lang='less' scoped>
.edit {
  .title {
    position: relative;
    height: 64px;
    display: flex;
    align-items: center;

    ._p {
      font-size: 16px;
      position: relative;
      color: #333333;

      &::after {
        content: "";
        position: absolute;
        width: 4px;
        left: -20px;
        top: 5px;
        bottom: 5px;
        background: #fabe00;
      }
    }
  }

  .grey{
    height: 20px;
    background: #F7F6F5;
    margin-left: -20px;
    margin-right: -20px;
  }
}
</style>